// LEGAL STATUS: To be legally validated before commercial production (EN translation of fr/CookiesPage.js).
import { Page, H1, H2, Lead, P, UL, Notice } from "../../public/primitives";

export const CookiesPage = () => (
  <Page testid="cookies-page">
    <H1>Cookies and local storage</H1>
    <Lead>
      SecurePass currently uses no advertising tracker and no third-party audience measurement.
    </Lead>

    <H2 id="situation">Current situation</H2>
    <P>The service <b>does not use</b>:</P>
    <UL>
      <li>Google Analytics;</li>
      <li>PostHog;</li>
      <li>advertising tracking;</li>
      <li>session recording (session replay);</li>
      <li>marketing trackers or advertising pixels.</li>
    </UL>

    <H2 id="stockage-necessaire">Necessary local storage</H2>
    <P>
      SecurePass only uses local storage that is strictly necessary for the service to work, in
      particular:
    </P>
    <UL>
      <li>the authentication token (when you are signed in);</li>
      <li>the active workspace;</li>
      <li>an anonymous session identifier used for anti-abuse protection.</li>
    </UL>
    <P className="text-slate-500">
      These items are not marketing trackers. Their values are not displayed here.
    </P>

    <H2 id="traceurs-optionnels">Optional trackers</H2>
    <P><b>None at present.</b> SecurePass does not enable any optional tracker.</P>
    <P className="text-slate-500">
      Some features deliberately triggered by the user may send a request to an external service. This is
      notably the case of the optional password check in Pwned Passwords (“Test a password” page). This is
      not a tracker.
    </P>

    <H2 id="preferences">Managing preferences</H2>
    <Notice tone="emerald" testid="cookies-preferences-note">
      No optional tracker requiring your consent is enabled.
    </Notice>
    <P className="text-slate-500">
      Should optional trackers be introduced in the future, preference management would be provided
      here.
    </P>
  </Page>
);

export default CookiesPage;
